import PaymentPlanTwoFactorAuthenticationError from './PaymentPlanTwoFactorAuthenticationError';
class W8ContractNotSigned extends PaymentPlanTwoFactorAuthenticationError {
    constructor(options) {
        super('Investor has not signed W8 contract', options);
    }
}
export default W8ContractNotSigned;
